import { render, staticRenderFns } from "./modalCrearPedido.vue?vue&type=template&id=b1f2c290&scoped=true"
import script from "./modalCrearPedido.vue?vue&type=script&lang=js"
export * from "./modalCrearPedido.vue?vue&type=script&lang=js"
import style0 from "./modalCrearPedido.vue?vue&type=style&index=0&id=b1f2c290&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f2c290",
  null
  
)

export default component.exports